import React from 'react'
import BkFlowRoomCardAdaDescription from '../accessiblity/BkFlowRoomCardAdaDescription'
import BkFlowRoomDetailsIcons from '../icons/BkFlowRoomDetailsIcons'

import yn from 'yn'

import brandPlaceholder from '../../../../assets/images/placeholder-image.png'

const BkFlowRoomCardRateStageDetails = props => {
	const {
		adaDescriptionEvent,
		adaDescriptionExpanded,
		cards,
		gallery,
		hotelLabels,
		roomGroup,
	} = props

	// default fallback room image
	let roomImage = brandPlaceholder,
			roomName = null,
			roomDescription = null

	// set room image to first in gallery
	if (
		gallery &&
		gallery[0] &&
		gallery[0].original
	) {
		roomImage = gallery[0].original
	}

	if (
		cards &&
		cards.roomDescription
	) {
		// set room type name
		if (cards.roomDescription.name) {
			roomName = cards.roomDescription.name
		}

		// set room type description
		if (cards.roomDescription.text) {
			roomDescription = cards.roomDescription.text
		}
	}

	return (
		<div className="bk-flow-room__card-rate-stage-room-details">
			{ roomImage &&
				<div
					className="bk-flow-room__card-rate-stage-room-details-image u-bg-image"
					style={{ backgroundImage: 'url(' + gallery[0].original + ')' }}
	      >
					<img className="u-element-hidden" src={roomImage} alt="Room Type Gallery" />
				</div>
			}

			<div className="bk-flow-room__card-rate-stage-room-details-content">
				{ roomName && <h6 className="title">{roomName}</h6> }

				{ roomDescription && <p className="description">{roomDescription}</p> }

				{ cards.viewExtensions &&
					cards.viewExtensions.adaDetails &&
					<BkFlowRoomCardAdaDescription
						adaDisclaimer={ cards.viewExtensions.adaDetails }
						hotelLabels={hotelLabels}
						toggledState={ adaDescriptionExpanded}
						toggleEvent={ adaDescriptionEvent}
					/>
				}

			 { yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ICONS) &&
					<BkFlowRoomDetailsIcons
						roomGroup={ roomGroup }
						roomData={ cards }
						displayAllIcons={true}
					/>
				}
			</div>
		</div>
	)
}

export default BkFlowRoomCardRateStageDetails



// WEBPACK FOOTER //
// ./src/components/room/elements/multi-stage/BkFlowRoomCardRateStageDetails.js